import enus from './en-us';
import ptbr from './pt-br';

const locales = {
  'en-us': enus,
  'pt-br': ptbr,
};

export default locales;
